import React from 'react';
import { Handle, Position } from 'reactflow';
import TopHeaderPanel from '../TopHeaderPanel';

function InitializerNode({id, data}) {
    const label = data?.label || 'Initializer Node';
    return (
      <div className='node-style'>
        <div className='thpw'>{data.selectedNodeId === id && <TopHeaderPanel />}</div>
        
      <div className="node">
        <div className='node_head'>
        <span><i className='ri-play-line'></i></span>
          {label} <i className="mdi mdi-close" onClick={(e) => {
              e.stopPropagation();
              if (data?.onDelete) {
                data.onDelete(id);
              }
            }}></i>
            <p>Initializer Node</p>
            </div>
            
            {/* <div className='node_body'>
                <div>
                  <label>Text</label>
                  <input defaultValue={data?.text || ''} placeholder="Receiving input" disabled/>
                </div>
              </div> */}
            
            <Handle type="source" position={Position.Right}/>
      </div>
      </div>
    )
}

export default InitializerNode